import Vue from 'vue';
import Component from 'vue-class-component';

import searchIcon from 'assets/icons/search_icon_new.svg';
import SearchResultSlug from 'components/SearchResultSlug/SearchResultSlug.vue';

@Component({
  props: {
    isPredictive: {
      type: Boolean,
      default: false,
      description: 'Boolean if show empty query or predictive',
    },
    activitiesSearchResults: {
      required: false,
      description: 'Activities objects from search',
    },
    suggestionsResults: {
      required: true,
      description: 'Suggestions to display',
    },
    searchValue: {
      required: false,
      description: 'Actual predictive search text',
    },
    loading: {
      required: true,
      type: Boolean,
    },
    isSpain: {
      required: true,
      type: Boolean,
    },
    allSearchResults: {
      required: false,
      type: Array,
    },
    containBoxesFlag: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
  components: {
    SearchResultSlug,
  },
})
export default class SearchOptionsComponent extends Vue {
  searchIcon = searchIcon;



  
  isBoxProduct(product) {
    return product?.child_type === 'Box';
  }

  isComboActivity(product) {
    return product?.child_type === 'ComboActivity';
  }

  isPartnerActivity(product) {
    return product?.child_type === 'PartnerActivity';
  }

  isProvinceType(product) {
    return product?.__typename === 'FilteredProvinceType';
  }

  getProductTypes(product) {
    return {
      isBox: this.isBoxProduct(product),
      isComboActivity: this.isComboActivity(product),
      isPartnerActivity: this.isPartnerActivity(product),
      isProvinceType: this.isProvinceType(product),
    };
  }

  /**
   * Crea la estructura base de un producto
   */
  createBaseProduct(product, { isBox }) {
    return {
      id: product?.id,
      name: product?.name,
      child_type: product.child_type || 'Box',
      product_url: isBox
        ? product.box?.product_url
        : product.partneractivity?.product_url,
      category: isBox
        ? product.box?.category
        : product.partneractivity?.category,
      ...(isBox && {
        count_activities_available_and_visible:
          product.box?.count_activities_available_and_visible,
      }),
    };
  }

  applyProductAdjustments(baseProduct, product, productTypes) {
    const result = { ...baseProduct };

    if (productTypes.isProvinceType) {
      result.category = 'Location';
      result.child_type = product.__typename;
      result.product_url = this.getUrlWithLocationParams('', { province: result.name });
    }

    if (
      productTypes.isPartnerActivity &&
      result.category?.name === 'Ocasiones'
    ) {
      result.category.name = result.name;
    }

    if (productTypes.isComboActivity) {
      result.product_url = product.comboactivity?.product_url;
      result.category = product.comboactivity?.category;
    }

    return result;
  }

  transformProduct(product) {
    const productTypes = this.getProductTypes(product);
    const baseProduct = this.createBaseProduct(product, productTypes);
    return this.applyProductAdjustments(baseProduct, product, productTypes);
  }
  getUrlWithLocationParams(keywords,filters) {
    const location = this.$router.resolve({
      name: 'products',
      query: {
        card: this.containBoxesFlag ? 0 : 1,
        ...keywords,
        ...filters,
      },
    });
   return location.href;
  }
  get searchText() {
    return this.isSpain
      ? 'Busca resultados de '
      : ' Ver todos los resultados de ';
  }

  /**
   * Computed property que transforma la lista de productos
   */
  get parseProductListResult() {
    return (
      this.allSearchResults?.map(product => this.transformProduct(product)) ||
      []
    );
  }
}
